import './MarketplaceBrokers.scss';
import React, { useEffect, useState } from 'react';
import { useStateSelector } from '../../../../store/selectors';
import BootstrapTable from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2';
import filterFactory from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2-filter';
import paginationFactory from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2-paginator';
import { TableFilter } from '../../../../components/Table/models/table-filter';
import { Button } from 'reactstrap';
import UserDetailsModal from '../../../Admin/Permissions/Users/Modal/UserDetailsModal';
import { useDispatch } from 'react-redux';
import { MarketplaceBroker } from '../../../../slices/marketplace/broker/models/broker';
import { GetBrokers } from '../../../../slices/marketplace/broker/thunks/get-brokers.thunk';
import Helpers from '../../../../utils/helper';
import { InviteNewBrokerModal } from './InviteNewBrokerModal/InviteNewBrokerModal';

export const MarketplaceBrokers = () => {
    const [page, setPage] = useState(1);
    const [totalSize, setTotalSize] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(5);
    const [data, setData] = useState<MarketplaceBroker[]>([]);
    const [isInviteNewBrokerModalVisible, setIsInviteNewBrokerModalVisible] =
        useState(false);
    const [isUserDetailsModalVisible, setIsUserDetailsModalVisible] =
        useState(false);
    const [selectedMarketplaceBroker, setSelectedMarketplaceBroker] =
        useState<MarketplaceBroker>(null);
    const defaultSorted: [{ dataField: any; order: any }] = [
        {
            dataField: 'name',
            order: 'asc',
        },
    ];
    const [currentSort, setCurrentSort] = useState<TableFilter>(
        new TableFilter({ filters: [], logic: '' }, page, sizePerPage, {
            dir: 'asc',
            field: 'name',
        })
    );
    const dispatch = useDispatch() as any;
    const brokersTable = useStateSelector(
        (state) => state.brokersState?.brokersTable
    );

    const fetchData = async (postObj: TableFilter) => {
        await dispatch(GetBrokers(postObj));
    };

    useEffect(() => {
        setData(brokersTable.brokers);
        setPage(brokersTable.pageNumber);
        setTotalSize(brokersTable.totalItems);
        setSizePerPage(brokersTable.pageSize);
    }, [brokersTable]);

    const handleTableChange = (_type: any, newState: any) => {
        const { page, sizePerPage, sortField, sortOrder } = newState;

        const updatedPostObj = new TableFilter(
            { filters: [], logic: '' },
            page,
            sizePerPage,
            { dir: sortOrder, field: sortField }
        );
        setCurrentSort(updatedPostObj);
        fetchData(updatedPostObj);
    };

    const showUserDetailPopup = (broker: MarketplaceBroker) => {
        setSelectedMarketplaceBroker(broker);
        setIsUserDetailsModalVisible(true);
    };

    const columns = [
        {
            dataField: 'name',
            text: 'Name',
            headerClasses: 'broker-name',
            sort: true,
            formatter: (cellContent: string, row: MarketplaceBroker) =>
                row.userId ? (
                    <div
                        className={'link'}
                        onClick={() => {
                            showUserDetailPopup(row);
                        }}>
                        {cellContent}
                    </div>
                ) : (
                    <div>{cellContent}</div>
                ),
        },
        {
            dataField: 'affiliation',
            text: 'Affiliation',
            headerClasses: 'affiliation-name',
            sort: true,
        },
        {
            dataField: 'email',
            headerClasses: 'email',
            text: 'Email',
            sort: true,
        },
        {
            dataField: 'currentEngagements',
            headerClasses: 'current-engagements',
            text: 'Current Engagements',
            sort: true,
        },
        {
            dataField: 'pastEngagements',
            headerClasses: 'past-engagements',
            text: 'Past Engagements',
            sort: true,
        },
        {
            dataField: 'activeObservingEngagements',
            headerClasses: 'active-observing-engagements',
            text: 'Active Observations',
            sort: true,
        },
        // {
        //     dataField: 'vvNetFeesEarned',
        //     headerClasses: 'vv-net-fees-earned',
        //     text: 'VetValue Net Fees Earned',
        //     sort: true,
        //     formatter: (cellContent: number) =>
        //         cellContent ? (
        //             <div className="money-cell">
        //                 {Helpers.currencyFormatWithBrackets(cellContent)}
        //             </div>
        //         ) : (
        //             '-'
        //         ),
        // },
        // {
        //     dataField: 'brokerFeesPaid',
        //     headerClasses: 'broker-fees-paid',
        //     text: 'Broker Fees Paid',
        //     sort: true,
        //     formatter: (cellContent: number) =>
        //         cellContent ? (
        //             <div className="money-cell">
        //                 {Helpers.currencyFormatWithBrackets(cellContent)}
        //             </div>
        //         ) : (
        //             '-'
        //         ),
        // },
    ];

    return (
        <div className="marketplace-brokers-tab">
            <div>
                <div className="mb-3 page-header">
                    <div className="header-title">Advisors</div>
                    <div>
                        <Button
                            type="button"
                            className="btn btn-primary ml-3 back-btn"
                            onClick={() => {
                                setIsInviteNewBrokerModalVisible(true);
                            }}>
                            Invite New Advisor
                        </Button>
                    </div>
                </div>

                <div
                    role="tabpanel"
                    id="panel-0"
                    aria-labelledby="tab-0"
                    aria-hidden="false">
                    <div className="card-body">
                        <BootstrapTable
                            bootstrap4
                            remote
                            keyField="id"
                            data={data}
                            columns={columns}
                            defaultSorted={defaultSorted}
                            filter={filterFactory()}
                            pagination={paginationFactory({
                                page,
                                sizePerPage,
                                totalSize,
                                tooltipTargetId: 'marketplace-brokers-tooltip',
                            })}
                            onTableChange={handleTableChange}
                            noDataIndication="No Advisors available"
                        />
                    </div>
                </div>
                {isInviteNewBrokerModalVisible && (
                    <InviteNewBrokerModal
                        isVisible={isInviteNewBrokerModalVisible}
                        onClose={() => {
                            setIsInviteNewBrokerModalVisible(false);
                            fetchData(currentSort);
                        }}
                    />
                )}
                {isUserDetailsModalVisible && (
                    <div className="user-details-popup">
                        <UserDetailsModal
                            onClose={() => {
                                setIsUserDetailsModalVisible(false);
                                fetchData(currentSort);
                            }}
                            isVisisble={isUserDetailsModalVisible}
                            userID={selectedMarketplaceBroker.userId}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
